// The Nordic lookup contract year on the customer page (ENG2-2461, T8 rule 6 /
// Phase 2 of ENG2-2452).
//
// The year starts on rights.global.nordic_subscription_start_date (T0 / D1) and
// rolls forward by whole years; RisikaAPI reports the current one as
// counters.nordic_lookups_current_period_start / _end (T6). RisikaAPI only
// accepts the start date in POST /company/update from the release that ships
// T6 on: the API before it rejects unknown rights.global keys. So the panel is
// shown only when the account status carries the period fields, which is
// exactly the API that accepts the key.

import moment from 'moment'
import { ACTIVE_SUBSCRIPTION_PLANS } from 'types'

export const NORDIC_START_DATE_KEY = 'nordic_subscription_start_date'

export const NORDIC_START_DATE_ELEMENT = {
  key: NORDIC_START_DATE_KEY,
  updateLocation: 'global',
}

export type NordicPeriod = { start: string; end: string }

type PeriodCounters = {
  nordic_lookups_current_period_start?: string | null
  nordic_lookups_current_period_end?: string | null
}

export type NordicContractYear =
  | { show: false }
  | { show: true; startDate: string | null; period: NordicPeriod | null }

export const nordicContractYear = (
  plan: string | undefined | null,
  counters: PeriodCounters | undefined,
  globalRights: Record<string, unknown> | undefined,
): NordicContractYear => {
  const isPackage =
    !!plan && (ACTIVE_SUBSCRIPTION_PLANS as readonly string[]).includes(plan)
  // `undefined` = the API does not know the field (before the release);
  // `null` = it does, and has no period for this customer yet.
  const apiKnowsPeriods =
    counters?.nordic_lookups_current_period_start !== undefined
  if (!isPackage || !apiKnowsPeriods) return { show: false }

  const start = counters?.nordic_lookups_current_period_start
  const end = counters?.nordic_lookups_current_period_end
  const startDate = globalRights?.[NORDIC_START_DATE_KEY]
  return {
    show: true,
    startDate: typeof startDate === 'string' ? startDate : null,
    period: start && end ? { start, end } : null,
  }
}

const day = (iso: string) =>
  moment(iso, 'YYYY-MM-DD').locale('en-gb').format('D MMM YYYY')

export const formatPeriod = (period: NordicPeriod): string =>
  `${day(period.start)} – ${day(period.end)}`
